import { Injectable } from '@angular/core';
import { Config } from '@configs/index.config';
import { environment } from '@environments/environment';
import { EClient } from '@Shared/enums/client.enum';
import { Config as SDKConfig } from 'ets-fe-ng-sdk';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor() {
    this.loadResources();
  }

  protected loadResources() {
    const client = environment.client;
    switch (client) {
      case EClient.ma:
        this.loadStyle('/assets/branding/ma/styles.ma.css');
        Config.Images = SDKConfig.Images = {
          favicon: {
            dark: `/assets/branding/ma/images/favicon/favicon.dark.svg`,
            light: `/assets/branding/ma/images/favicon/favicon.light.svg`,
          },
          logo: {
            dark: `/assets/branding/ma/images/logo/logo.dark.svg`,
            light: `/assets/branding/ma/images/logo/logo.light.svg`,
          },
        };
        environment.appName = `MAIDS Portal`;
        break;

      default:
        Config.Images = SDKConfig.Images = {
          favicon: {
            dark: `/assets/img/ets/favicon.ets.png`,
            light: `/assets/img/ets/favicon.ets.png`,
          },
          logo: {
            dark: `/assets/img/ets/logos/logo.dark.ets.png`,
            light: `/assets/img/ets/logos/logo.dark.ets.png`,
          },
        };
        break;
    }
    this.loadAppName();
    this.loadFavIcon();
  }

  protected loadStyle(path: string) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = path;
    link.type = 'text/css';

    document.querySelector('head')?.appendChild(link);
  }

  protected loadAppName() {
    const tag = document.querySelector('head title#appName');
    if (tag) tag.innerHTML = environment.appName;
  }

  protected loadFavIcon() {
    const links = [
      SDKConfig.Images?.favicon?.light,
      SDKConfig.Images?.favicon?.dark,
      SDKConfig.Images?.favicon?.light,
    ].filter((x) => !!x);
    if (links.length)
      for (let index = 0; index < links.length; index++) {
        const path = links[index];

        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = path;
        link.type = path.endsWith('.svg') ? 'image/svg+xml' : 'image';
        if (index == 1) link.media = '(prefers-color-scheme: dark)';
        else if (index == 2) link.media = '(prefers-color-scheme: light)';

        document.querySelector('head')?.appendChild(link);
      }
  }
}
